import { FormHelperText, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const ErrorTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.red.main,
  fontSize: '0.85rem',
  fontWeight: 400,
}));

export const FormHeaderText = styled(Typography)(() => ({
  fontSize: '2.125rem',
  fontWeight: 400,
  marginBottom: '0',
  textAlign: 'left',
}));

export const PatientCardText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '22px',
}));

export const PatientHeader = styled(Typography)(() => ({
  fontSize: '32px',
  fontWeight: 700,
  lineHeight: '32px',
  wordBreak: 'break-word',
}));

export const PatientHeaderSubtext = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '22px',
}));

export const PatientSubHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
}));

export const StyledDetailDescription = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '18px',
}));

export const StyledDetailNotes = styled(Typography)(() => ({
  fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
  lineHeight: 1.5,
  letterSpacing: '0.00938rem',
  fontSize: '16px',
  fontWeight: 400,
  marginBottom: '16px',
}));

export const StyledFormLabel = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.grey.darker,
  fontSize: '14px',
  marginLeft: '0.25rem',
  textTransform: 'uppercase',
}));
